// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ArchivedLogsController = function ($scope, $routeParams, Logs, $filter) {

    const RowsOnPage = 50;
    
    function setDefaultPeriod() {
        $scope.filter.after = moment().subtract(1, 'hours').toISOString(true);
        $scope.filter.before = moment().toISOString(true);
    }

    function getBeforeFromAfter(after) {
        return moment(after).add(1, 'hours').toISOString(true);
    }

    function getAfterFromBefore(before) {
        return moment(before).subtract(1, 'hours').toISOString(true);
    }

    function getISODateOrDefault(date) {
        return moment(date).isValid() ? moment(date).toISOString(true) : moment().toISOString(true);
    }

    function setPeriodFilterDefaults() {
        if (!moment($scope.filter.after).isValid() && !moment($scope.filter.before).isValid()) {
            setDefaultPeriod();
        } else if (moment($scope.filter.after).isValid() && !moment($scope.filter.before).isValid()) {
            $scope.filter.after = getISODateOrDefault($scope.filter.after);
            $scope.filter.before = getBeforeFromAfter($scope.filter.after);
        } else if (!moment($scope.filter.after).isValid() && moment($scope.filter.before).isValid()) {
            $scope.filter.before = getISODateOrDefault($scope.filter.before);
            $scope.filter.after = getAfterFromBefore($scope.filter.before);
        } else {
            $scope.filter.after = moment($scope.filter.after).toISOString(true);
            $scope.filter.before = moment($scope.filter.before).toISOString(true);
        }
    }
    $scope.isArchiveController = true;

    $scope.filter = {
        Collection : "",
        before: getISODateOrDefault($routeParams.before),
        after: getAfterFromBefore(getISODateOrDefault($routeParams.before)),
        min: $routeParams.from,
        merchant: "",
    };

    $scope.serverCollectionFilter = "All";
    $scope.archivedCollections = ["All"];
    Logs.queryCollections().$promise.then(function(result) {
        $scope.archivedCollections = $scope.archivedCollections.concat(result.CollectionNames);
    });

    $scope.setPaginatorFilter = function () {
        $scope.logs.filter($scope.clientFilter);
    };
    
    function filterItems(allModels, searchInput) {
        var hasFilter = searchInput && (Object.getOwnPropertyNames(searchInput).length > 0);
        
        return hasFilter? $filter('allowEmptyFilter')(allModels, searchInput) : allModels;
    }
    
    $scope.getPaginator = function (allItems) {
        return $scope.clientPaginator(allItems, RowsOnPage, filterItems, (obj) => { return obj.Id;});
    }

    $scope.resultCollections = [];

    $scope.isTimePeriodValid = function() {
        if (!$scope.filter.after || !$scope.filter.before)
            return false;
        var startTime = new Date($scope.filter.after);
        var endTime = new Date($scope.filter.before);

        return endTime >= startTime;
    };

    $scope.setPrevTimePeriod = function() {
        if (!$scope.filter.after || !$scope.filter.before)
            return;
        var startTime = new Date($scope.filter.after);
        var endTime = new Date($scope.filter.before);

        if (endTime < startTime)
            return;
        // Calculate time difference in milliseconds
        var timeDifference = endTime - startTime;

        // Create a new date based on the end date + time difference
        var newStartDate = new Date(startTime.getTime() - timeDifference);

        // Update the values
        $scope.filter.after = getISODateOrDefault(newStartDate);
        $scope.filter.before = getISODateOrDefault(startTime);
    };

    $scope.setNextTimePeriod = function() {
        if (!$scope.filter.after || !$scope.filter.before)
            return;
        var startTime = new Date($scope.filter.after);
        var endTime = new Date($scope.filter.before);

        if (endTime < startTime)
            return;
        // Calculate time difference in milliseconds
        var timeDifference = endTime - startTime;

        // Create a new date based on the end date + time difference
        var newEndDate = new Date(endTime.getTime() + timeDifference);

        // Update the values
        $scope.filter.after = getISODateOrDefault(endTime);
        $scope.filter.before = getISODateOrDefault(newEndDate);
    };
    
    $scope.loadArchivedLogs = function () {
        setPeriodFilterDefaults();
        
        var options = {
            application: $scope.filter.application,
            severity: $scope.filter.severity,
            before: $scope.filter.before,
            after: $scope.filter.after,
            min: $scope.filter.from,
            requestLogId: $scope.filter.requestLogId,
            message : $scope.filter.message,
            merchant: $scope.filter.merchant,
            collectionName: $scope.serverCollectionFilter === 'All' ? null : $scope.serverCollectionFilter
        };

        Logs.queryArchived(options).$promise.then(function(result) {
            
            var logs = [];
            var foundCollections = {};
            for (var i = 0; i < result.length; i++)
            {
                var log = result[i];
                log.LogDocument.Collection = log.CollectionName;
                if (log.GrouppedId)
                    log.LogDocument.EntityId = log.GrouppedId;
                foundCollections[log.CollectionName] = 1;
                $scope.getJson(log.LogDocument)
                logs.push(log.LogDocument);
            }

            $scope.clearResults();
            for (const foundCollectionsKey in foundCollections) {
                $scope.resultCollections.push(foundCollectionsKey);
            }
            $scope.logs = $scope.getPaginator(logs);
            
        });

        $scope.clearResults = function(log) {
            $scope.resultCollections = [];
            $scope.logs = $scope.getPaginator([]);
            $scope.clientFilter = {};
        };
        
        $scope.getJson = function(log) {
            if (!log.Json)
                log.Json = JSON.stringify(log, null, 2);
            
            return log.Json;
        }

        $scope.clearResults();
    };

};
ArchivedLogsController.$inject = ['$scope', '$routeParams', 'Logs', '$filter'];
